import { AxiosRequest } from "../common/axios-request";
import {
  GET_ALL_PROMOTIONAL_NOTIFICATION_LIST,
  CREATE_PROMOTIONAL_NOTIFICATION,
  UPDATE_PROMOTIONAL_NOTIFICATION,
  DELETE_PROMOTIONAL_NOTIFICATION,
  GET_PROMOTIONAL_NOTIFICATION,
} from "../common/constant";

const GetAllPromotionalNotificationList = () => {
  return AxiosRequest.get(GET_ALL_PROMOTIONAL_NOTIFICATION_LIST);
};

const CreatePromotionalNotification = (payload: any) => {
  return AxiosRequest.post(CREATE_PROMOTIONAL_NOTIFICATION, payload);
};

const UpdatePromotionalNotification = (id: string, payload: any) => {
  return AxiosRequest.put(
    UPDATE_PROMOTIONAL_NOTIFICATION.replace(":id", id),
    payload
  );
};

const DeletePromotionalNotification = (id: string) => {
  return AxiosRequest.delete(
    DELETE_PROMOTIONAL_NOTIFICATION.replace(":id", id)
  );
};

const GetPromotionalNotification = (id: string) => {
  return AxiosRequest.get(GET_PROMOTIONAL_NOTIFICATION.replace(":id", id));
};

export {
  GetAllPromotionalNotificationList,
  CreatePromotionalNotification,
  UpdatePromotionalNotification,
  DeletePromotionalNotification,
  GetPromotionalNotification,
};
